import React from 'react'

export default function CompletedSolutions() {
  return (
    <div>CompletedSolutions</div>
  )
}
